module.exports = __webpack_public_path__ + "static/media/html.6889d021.png";